import { useServerEnrolledStatsigExperiment } from '../../context/experiments/hooks';
import { SearchDesktopMapExperiment } from '../../types/Experiments';

export const useMapExperiment = () => {
    const mapExperiment = useServerEnrolledStatsigExperiment<string>({
        name: SearchDesktopMapExperiment.name,
        paramName: SearchDesktopMapExperiment.paramName,
        defaultValue: SearchDesktopMapExperiment.values.control,
    });

    return mapExperiment.variant === SearchDesktopMapExperiment.values.variant;
};
